/* eslint-disable no-shadow */
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Button from 'li-components/lib/next/Button'
import TargetBlank from 'li-components/lib/TargetBlank'
import Spinner from 'li-components/lib/Spinner'
import SvgIcon from 'li-components/lib/SvgIcon'

import { tourName, track } from '../../util'
import {
  Sidebar,
  SidebarMain,
  SidebarMainHeaderSection,
  SidebarMainMiddleSection,
  SidebarMainBottomSection,
  SidebarFooter,
  SidebarCloseButton,
  List,
} from '../../components/styled'
import {
  searchArticles,
  setQuery,
  submitRequest,
  uploadAttachment,
  removeUpload,
  setArticleId,
  getReleaseNotes,
  persistSeenReleaseNoteIds,
  selectors,
} from '../redux'
import { initZendeskWidget } from '../api'
import HelpIcon from './HelpIcon'
import SearchInput from './SearchInput'
import Contact from './Contact'
import ReleaseNotes from './ReleaseNotes'
import {
  Header,
  Article,
  ArticleBody,
  ViewAllLink,
  MenuItem,
  MenuItemBadge,
  Rule,
} from './styled'

const mapStateToProps = state => ({
  articles: state.help.articles,
  articlesLoading: state.help.articlesLoading,
  query: state.help.query,
  uploads: state.help.uploads,
  uploading: state.help.uploading,
  requestPending: state.help.requestPending,
  articleId: state.help.articleId,
  releaseNotes: state.help.releaseNotes,
  seenReleaseNoteIds: state.help.seenReleaseNoteIds,
  unseenReleaseNotesCount: selectors.getUnseenReleaseNotesCount(state),
})

const mapDispatchToProps = {
  searchArticles,
  setQuery,
  submitRequest,
  uploadAttachment,
  removeUpload,
  setArticleId,
  getReleaseNotes,
  persistSeenReleaseNoteIds,
}

export class HelpCenter extends Component {
  static propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    articles: PropTypes.object.isRequired,
    articlesLoading: PropTypes.bool.isRequired,
    searchArticles: PropTypes.func.isRequired,
    query: PropTypes.string.isRequired,
    setQuery: PropTypes.func.isRequired,
    submitRequest: PropTypes.func.isRequired,
    uploadAttachment: PropTypes.func.isRequired,
    uploads: PropTypes.array.isRequired,
    uploading: PropTypes.bool.isRequired,
    removeUpload: PropTypes.func.isRequired,
    requestPending: PropTypes.bool.isRequired,
    articleId: PropTypes.string.isRequired,
    setArticleId: PropTypes.func.isRequired,
    getReleaseNotes: PropTypes.func.isRequired,
    releaseNotes: PropTypes.array.isRequired,
    unseenReleaseNotesCount: PropTypes.number.isRequired,
    persistSeenReleaseNoteIds: PropTypes.func.isRequired,
  }

  static contextTypes = {
    appId: PropTypes.string.isRequired,
    helpLabel: PropTypes.string,
    hasChat: PropTypes.bool.isRequired,
  }

  state = {
    articlesLoaded: false,
    releaseNotesLoaded: false,
    showContactForm: false,
    showReleaseNotes: false,
  }

  componentWillMount() {
    this.props.getReleaseNotes(this.context.helpLabel || this.context.appId)
    this.initZendeskWidget()
  }

  componentWillReceiveProps(nextProps) {
    this.safeGetArticles(nextProps)
  }

  initZendeskWidget() {
    if (this.context.hasChat) {
      initZendeskWidget()
    }
  }

  safeGetArticles(props) {
    if (props.show && !props.articlesLoading && !this.state.articlesLoaded) {
      this.setState({ articlesLoaded: true })
      this.search()
    }
  }

  onChangeQuery = e => {
    const query = e.currentTarget.value
    this.props.setQuery(query)
    this.search(query)

    if (HelpCenter.trackSearchTimeout) {
      clearTimeout(HelpCenter.trackSearchTimeout)
    }

    HelpCenter.trackSearchTimeout = setTimeout(() => {
      track.helpCenter({ event: 'search', label: query })
    }, 1000)
  }

  search(query) {
    if (query && query.trim()) {
      this.props.searchArticles(query)
    } else if (this.context.helpLabel) {
      this.props.searchArticles(undefined, this.context.helpLabel)
    } else {
      this.props.searchArticles(this.context.appId)
    }
  }

  getViewAllArticlesHref() {
    const { query } = this.props
    const url = `https://helpdesk.labelinsight.com/hc/en-us`

    return query ? `${url}/search?utf8=✓&query=${query}` : url
  }

  toggleContactForm = () => {
    const showContactForm = !this.state.showContactForm
    this.setState({ showContactForm })
    track.helpCenter({
      event: showContactForm ? 'enterContactForm' : 'exitContactForm',
    })
  }

  canChat() {
    return this.context.hasChat && global.$zopim
  }

  openChat = () => {
    global.zE.activate({ hideOnClose: true })
    global.$zopim.livechat.window.show()
    track.helpCenter({ event: 'openChat' })
  }

  onClickArticle(articleId) {
    this.props.setArticleId(
      this.props.articleId === articleId ? '' : String(articleId)
    )
  }

  onClickOutside = () => {
    if (this.props.show) {
      this.props.onClose()
    }
  }

  shouldShowContactButton() {
    return !this.state.showContactForm && !this.state.showReleaseNotes
  }

  onClickReleaseNotesMenuItem = () => {
    this.setState({
      showReleaseNotes: true,
    })
    this.persistSeenReleaseNoteIds()
    track.helpCenter({ event: 'releaseNotesClick' })
  }

  persistSeenReleaseNoteIds() {
    this.props.persistSeenReleaseNoteIds(
      this.props.releaseNotes.map(releaseNote => releaseNote.id)
    )
  }

  hideReleaseNotes = () => {
    this.setState({
      showReleaseNotes: false,
    })
  }

  shouldShowReleaseNotesMenuItem() {
    return this.props.releaseNotes.length > 0
  }

  render() {
    const {
      show,
      articles,
      articlesLoading,
      onClose,
      query,
      uploadAttachment,
      uploads,
      uploading,
      removeUpload,
      submitRequest,
      requestPending,
      articleId,
      releaseNotes,
      unseenReleaseNotesCount,
    } = this.props
    const canChat = this.canChat()

    return (
      <Sidebar
        open={show}
        className="HelpCenter"
        onClickOutside={this.onClickOutside}
      >
        <Header>
          <h2>
            <HelpIcon color="white" />&nbsp;&nbsp;Help
          </h2>
          <SidebarCloseButton
            onClick={onClose}
            data-tour={tourName('help-close')}
          >
            &times;
          </SidebarCloseButton>
        </Header>
        {show &&
          (this.state.showContactForm ? (
            <Contact
              show={this.state.showContactForm}
              onClose={this.toggleContactForm}
              onSubmit={submitRequest}
              onCancel={this.toggleContactForm}
              uploadAttachment={uploadAttachment}
              uploading={uploading}
              uploads={uploads}
              removeUpload={removeUpload}
              requestPending={requestPending}
            />
          ) : this.state.showReleaseNotes && releaseNotes.length > 0 ? (
            <ReleaseNotes
              onClickBackButton={this.hideReleaseNotes}
              releaseNotes={releaseNotes}
            />
          ) : (
            <SidebarMain>
              <SidebarMainHeaderSection>
                <h4>How can we help?</h4>
                <SearchInput
                  value={query}
                  onChange={this.onChangeQuery}
                  data-tour={tourName('help-search')}
                />
              </SidebarMainHeaderSection>
              <SidebarMainMiddleSection>
                {articlesLoading || !articles.results ? (
                  <Spinner isShowing />
                ) : (
                  <List>
                    {articles.results.map(article => {
                      const id = String(article.id)
                      const isOpen = id === articleId

                      return (
                        <Article
                          key={id}
                          onClick={() => {
                            this.onClickArticle(id)
                            track.helpCenter({
                              event: 'articleClick',
                              label: article.title,
                              property: article.id,
                            })
                          }}
                          data-tour={tourName('help-click-article')}
                        >
                          <div>
                            {isOpen ? <em>{article.title}</em> : article.title}
                            <SvgIcon name={isOpen ? 'down-2' : 'right-2'} />
                          </div>
                          {isOpen && (
                            <ArticleBody>
                              <main
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{
                                  __html: article.body,
                                }}
                              />
                              <footer>
                                <TargetBlank
                                  href={article.html_url}
                                  title="View article in Helpdesk"
                                  data-tour={tourName('help-view-full-article')}
                                  onClick={() => {
                                    track.helpCenter({
                                      event: 'viewFullArticleClick',
                                      label: article.title,
                                      property: article.id,
                                    })
                                  }}
                                >
                                  View article in Helpdesk
                                  <SvgIcon name="external-link-square-2" />
                                </TargetBlank>
                              </footer>
                            </ArticleBody>
                          )}
                        </Article>
                      )
                    })}
                    {articles.count > 10 && (
                      <ViewAllLink>
                        <TargetBlank
                          href={this.getViewAllArticlesHref()}
                          title="View Full Helpdesk"
                          data-tour={tourName('help-all-articles')}
                          onClick={() => {
                            track.helpCenter({ event: 'viewAllArticlesClick' })
                          }}
                        >
                          View all {query ? 'search results' : 'articles'}
                        </TargetBlank>
                      </ViewAllLink>
                    )}
                  </List>
                )}
              </SidebarMainMiddleSection>
              <SidebarMainBottomSection>
                <List>
                  {this.shouldShowReleaseNotesMenuItem() && (
                    <MenuItem
                      onClick={this.onClickReleaseNotesMenuItem}
                      data-tour={tourName('help-release-notes')}
                    >
                      <span>
                        <h4>What&apos;s New?</h4>
                        {unseenReleaseNotesCount > 0 && (
                          <MenuItemBadge>
                            {unseenReleaseNotesCount}
                          </MenuItemBadge>
                        )}
                        <SvgIcon name="right-2" />
                      </span>
                    </MenuItem>
                  )}
                  <MenuItem>
                    <TargetBlank
                      href="https://helpdesk.labelinsight.com/hc/en-us"
                      title="View Full Helpdesk"
                      data-tour={tourName('help-view-helpdesk')}
                    >
                      <h4>View Full Helpdesk</h4>
                      <SvgIcon
                        className="large"
                        name="external-link-square-2"
                      />
                    </TargetBlank>
                  </MenuItem>
                </List>
              </SidebarMainBottomSection>
            </SidebarMain>
          ))}
        {this.shouldShowContactButton() && (
          <SidebarFooter>
            {canChat && (
              <Fragment>
                <Button
                  kind="primary"
                  block
                  onClick={this.openChat}
                  data-tour={tourName('help-chat-button')}
                >
                  CHAT
                </Button>
                <Rule>OR</Rule>
              </Fragment>
            )}
            <Button
              kind="primary"
              block
              onClick={this.toggleContactForm}
              data-tour={tourName('help-contact-button')}
            >
              CONTACT
            </Button>
          </SidebarFooter>
        )}
      </Sidebar>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HelpCenter)



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/help/components/HelpCenter.js